import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { Row, Col } from 'antd'

import { Title, Text } from 'src/components/Ant'
import { ApplicationState } from 'src/store'

import { WrapSectionHeader } from './styles'

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R2Header: { data }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const startDate = `${
    moment(moment.unix(data[0].start_date).utc().format('YYYYMMDD')).format(
      'DD/MM/YYYY'
    ) || '-'
  }`
  const endDate = `${
    moment(moment.unix(data[0].end_date).utc().format('YYYYMMDD')).format(
      'DD/MM/YYYY'
    ) || '-'
  }`

  return (
    <WrapSectionHeader>
      <Row>
        <Col span={24}>
          <Title id="subtitle" level={4} title="web.report.2.header.title" />
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.2.header.request_number">
            <span id="value">
              {data[0].request_number ? `#${data[0].request_number}` : ' - '}
            </span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.2.header.start_date">
            <span id="value">{startDate}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16} />
        <Col span={8}>
          <Text colon id="header" title="web.report.2.header.end_date">
            <span id="value">{endDate}</span>
          </Text>
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
